import React from 'react'
// components
import { PopoverModal } from 'components/UI'
// constants
import { Modals } from 'constants/modals'
// context
import { PlansPageContext } from 'containers/Plan/Register/layers/API'
// hooks
import { useShowModal } from 'hooks/index'
// views
import { DotsIcon, TableCell } from 'themes/views/tables'
// view components
import Menu from './Menu'
// types
import { IPlan } from 'types/graphql'

const MODAL_PROPS = {
  anchorOrigin: {
    vertical: 'bottom' as const,
    horizontal: 'right' as const
  },
  transformOrigin: {
    vertical: 'top' as const,
    horizontal: 'right' as const
  }
}

interface Props {
  data: IPlan
}

const PlanActionsMenu: React.FC<Props> = ({ data }) => {
  const { deletePlan } = React.useContext(PlansPageContext)

  const { planCreateSubPlan, planDeletePlan } = data.currentPermissions

  const { showModal } = useShowModal({ modalType: Modals.CONFIRM_DELETE_MODAL })

  const { id, name } = data

  const handleDeleteClick = () =>
    showModal({
      entity: name,
      handleConfirm: () => deletePlan(id)
    })

  return planCreateSubPlan || planDeletePlan ? (
    <TableCell size={5}>
      <PopoverModal {...MODAL_PROPS} trigger={<DotsIcon />}>
        {({ closePopup }) => <Menu data={data} closePopup={closePopup} handleDeleteClick={handleDeleteClick} />}
      </PopoverModal>
    </TableCell>
  ) : (
    <TableCell size={5} />
  )
}

export default PlanActionsMenu
